'use client';

import type { ComponentProps } from 'react';

import { Link } from '@/components/Link/Link';
import { PressReleaseExample } from '@/components/PressReleaseExample/PressReleaseExample';
import { usePressReleaseExampleModal } from '@/components/PressReleaseExample/usePressReleaseExampleModal';
import type { Example } from '@/types';

import { Card } from '../Card/Card';
import { ExampleModal } from '../ExampleModal';

import styles from './ExampleCard.module.scss';

type Props = ComponentProps<typeof Card> & {
    slug: string;
    example?: Example;
};

export function ExampleCard({ title, slug, path, example, ...restProps }: Props) {
    const modal = usePressReleaseExampleModal(example);

    return (
        <>
            <Link className={styles.cardWrapper} href={path} onClick={modal.open}>
                <Card
                    doNotWrapWithLink
                    title={title}
                    className={styles.card}
                    path={path}
                    {...restProps}
                />
            </Link>

            {example && (
                <ExampleModal
                    title={title}
                    content={<PressReleaseExample example={example} isModal />}
                    open={modal.isOpen}
                    onClose={modal.close}
                />
            )}
        </>
    );
}
